import { Styles } from "@chakra-ui/theme-tools";

export const styles: Styles = {
  global: {
    body: {
      backgroundColor: "#020E20",
    },
  },
};
